import { jsx as e, jsxs as o } from "react/jsx-runtime";
import { tv as c } from "tailwind-variants";
import m from "./Heading.js";
import r from "./Jumbotron.js";
const a = c({
  base: [
    "flex",
    "flex-col",
    "gap-4",
    "items-center",
    "max-w-[theme(containerWidth.sm)]",
    "mx-auto",
    "py-10",
    "text-center"
  ]
}), i = ({ className: s, children: t }) => /* @__PURE__ */ e(r, { className: "px-5", children: /* @__PURE__ */ o("div", { className: a({ class: s }), children: [
  /* @__PURE__ */ e(
    "img",
    {
      alt: "",
      src: "https://res.cloudinary.com/dz209s6jk/image/upload/v1709046170/DesignSystem/icon-lock.svg"
    }
  ),
  t
] }) });
i.Heading = m;
export {
  i as default
};
